export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FacultyCategory.vue?vue&type=template&id=a27c6906"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/FacultyCategory.vue?vue&type=template&id=a27c6906
// module id = 397
// module chunks = 0